import produce from 'immer';
import { ActionTypes } from '../actions/wishList';

export const initialState = [];

/* eslint-disable no-param-reassign */
function appWishListReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.CHANGE:
                draft = draft.length === 0 && action.list.length === 0 ? draft : action.list;
                return draft;
            case ActionTypes.ADD:
                draft = draft.concat([action.id]).filter(Boolean);
                return draft;
            case ActionTypes.REMOVE:
                draft = draft.filter((id) => id !== action.id).filter(Boolean);
                return draft;
            default:
                return draft;
        }
    });
}

export default appWishListReducer;
